var exports = {
  "DD": "title__tddXS3",
  "J$": "pickerContentContainer__14MPA8",
  "cn": "pickerLabelText__77O9Qz",
  "tL": "leadingIconContainer__oLy1O3",
  "df": "leadingIconContainerHidden__nQmPby",
  "sy": "dashedPickerButton__LRIkcZ",
  "My": "hotkeyBadge__OvREdl",
};

module.exports = exports;
